import { TemplateRef } from '@angular/core';
import { EAccess, EAccessMethod } from '@app/access/access.model';
import { InputControllerTypes } from 'common/enums';

export enum EvideTableColumnComponent {
  Input = 'input',
  Dropdown = 'dropdown',
  MultiSelect = 'dropdown-multiselect',
  Toggle = 'toggle',
  Textarea = 'textarea',
  Editor = 'editor',
  KeyValue = 'key-value'
}

export enum EvideTableColumnType {
  Text = 'text',
  Textarea = 'textarea',
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
  Email = 'email',
  Password = 'password',
  Options = 'options',
  Action = 'action',
  Checkbox = 'checkbox',
  Date = 'date',
  Link = 'link',
  Badge = 'badge'
}

export interface AccessVisibilityCheckType {
  controllerKey: EAccess;
  methodKey: EAccessMethod;
  ngIf?: boolean;
  else?: TemplateRef<any>;
}

export interface AccessDisableCheckType {
  controllerKey: EAccess;
  methodKey: EAccessMethod;
  disable?: boolean;
}

export interface EvideTableColumn {
  key: string;
  type: EvideTableColumnType;
  title: string;
  compType?: EvideTableColumnComponent;
  matIcon?: string;
  optionMenu?: EvideTableColumn[];
  isFormField?: boolean;
  isFormEditableField?: boolean;
  displayValue?: boolean;
  required?: boolean;
  required_error?: string;
  sortable?: boolean;
  hideInList?: boolean;
  displayDynamicInput?: boolean;
  placeholder?: string;
  accessVisibility?: AccessVisibilityCheckType;
  accessDisable?: AccessDisableCheckType;
  pattern?: string;
  pattern_error?: string;
}

export interface KeyValue<T, U> {
  key: T;
  value: U;
}
export enum ComponetValueType {
  String,
  Number,
  DateTime,
  Boolean,
  Array,
  Time,
  // A repeatable table: the control value is an array of rows (handled by the grid renderer, not
  // by the scalar value marshallers).
  Table
}
export const InputControllerTypesToValueType: Record<InputControllerTypes, ComponetValueType> = {
  [InputControllerTypes.TextBox]: ComponetValueType.String,
  [InputControllerTypes.TextArea]: ComponetValueType.String,
  [InputControllerTypes.Numeric]: ComponetValueType.Number,
  [InputControllerTypes.Dropdown]: ComponetValueType.String,
  [InputControllerTypes.RadioButtons]: ComponetValueType.String,
  [InputControllerTypes.Checkboxes]: ComponetValueType.Array,
  [InputControllerTypes.DatePicker]: ComponetValueType.DateTime,
  [InputControllerTypes.TimePicker]: ComponetValueType.Time,
  [InputControllerTypes.DateTimePicker]: ComponetValueType.DateTime,
  [InputControllerTypes.Toggle]: ComponetValueType.Boolean,
  [InputControllerTypes.Label]: ComponetValueType.String,
  [InputControllerTypes.Checkbox]: ComponetValueType.Boolean,
  [InputControllerTypes.DropdownMulti]: ComponetValueType.Array,
  [InputControllerTypes.DropdownWithExtraText]: ComponetValueType.String,
  [InputControllerTypes.RepeatableTable]: ComponetValueType.Table
};
